/* eslint object-curly-newline: 0 */

import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  key: 'kopplr',
  storage: window.localStorage
})

Vue.use(Vuex);

const user = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  landline: '',
  fax: '',
  phoneVerified: '',
  password: '',
  birthDate: '',
  language: ''
};

const company = {
  name: '',
  shopUrl: '',
  shopCountry: '',
  industry: '',
  yearlyTurnover: '',
  averageTicketSize: '',
  eCommerce: false,
  salePoint: false,
  posNumber: 0,
  shopSystem: '',
  companyUrl: '',
  language: '',
  checkoutLanguage: '',
  streetAndNumber: '',
  zip: '',
  city: '',
  country: '',
  state: '',
  vat: ''
}

const bank = {
  // payoutSettlement: false,
  name: '',
  accountNumber: '',
  swift: '',
  bankCode: '',
  iban: '',
  accountOwnerName: '',
  streetAndNumber: '',
  zip: '',
  city: '',
  country: '',
  state: '',
  shopCurrencies: [],
  transactionCurrencies: [],
  payoutCurrency: ''
}

const paymentAcceptance = [
  { name: 'Mastercard', model: 'mastercard', selected: false, price: 0.25, percentage: 1.8 },
  { name: 'Visa', model: 'visa', selected: false, price: 0.25, percentage: 1.2 },
  { name: 'Maestro', model: 'maestro', selected: false, price: 0.25, percentage: 0.8 },
  { name: 'Diners Club', model: 'diners-club', selected: false, price: 0.25, percentage: 1.3 },
  { name: 'JCB', model: 'jcb', selected: false, price: 0.25, percentage: 0.1 },
  { name: 'Amex', model: 'amex', selected: false, price: 0.25, percentage: 0.4 },
  // { name: 'Alipay', model: 'alipay', selected: false, price: 0.25, percentage: 1.2 },
  { name: 'PayPal', model: 'paypal', selected: false, price: 0.25, percentage: 1.1 },
  { name: 'Sepa', model: 'sepa', selected: false, price: 0.25, percentage: 1.0 },
  { name: 'Klarna', model: 'klarna', selected: false, price: 0.25, percentage: 0.1 },
  { name: 'Eps', model: 'eps', selected: false, price: 0.25, percentage: 1.8 },
  { name: 'ideal', model: 'ideal', selected: false, price: 0.25, percentage: 0.7 },
  { name: 'Bitcoin', model: 'bitcoin', selected: false, price: 0.25, percentage: 0.1 },
  { name: 'Ethereum', model: 'ethereum', selected: false, price: 0.25, percentage: 1.8 },
  { name: 'Dash', model: 'dash', selected: false, price: 0.25, percentage: 0.7 }
]

const services = [
  { name: 'Risk Management', model: 'risk-management', selected: false, price: 0.25, percentage: 1.3 },
  { name: 'Fraud Prevention', model: 'fraud-prevention', selected: false, price: 0.25, percentage: 1.1 },
  { name: 'Realtime Analytics', model: 'realtime-analytics', selected: false, price: 0.25, percentage: 1.6 },
  { name: 'No reserve', model: 'no-reserve', selected: false, price: 0.25, percentage: 0.3 },
  { name: 'Chargeback Notification email', model: 'notification-email', selected: false, price: 0.25, percentage: 0.8 },
  { name: 'Multi Currency Payout', model: 'multi-currency', selected: false, price: 0.25, percentage: 1.7 },
  { name: 'Invoicing', model: 'invoicing', selected: false, price: 0.25, percentage: 1.1 },
  { name: 'Recurring Payments / Subscriptions', model: 'subscriptions', selected: false, price: 0.25, percentage: 1.3 },
  { name: 'Cyber Security', model: 'cyber-security', selected: false, price: 0.25, percentage: 0.2 },
  { name: 'Acceptance without 3D Secure', model: '3d-secure', selected: false, price: 0.25, percentage: 0.5 },
  { name: 'Countertop Terminal', model: 'terminal', selected: false, price: 0.25, percentage: 0.5 },
  { name: 'Chatbot integration', model: 'chatbot', selected: false, price: 0.25, percentage: 0.5 },
  { name: 'Shufti Pro - KYC/AML', model: 'aml', selected: false, price: 0.25, percentage: 0.5 }
]

// const banking = [
//   { name: 'Merchant Banking', model: 'merchant-banking', selected: false, price: 0.25, percentage: 1.8 },
//   { name: 'Giro Maestro', model: 'giro-maestro', selected: false, price: 0.25, percentage: 1.2 },
//   { name: 'Prepaid Visa', model: 'prepaid-visa', selected: false, price: 0.25, percentage: 1.1 }
// ]

// const apps = [
//   { name: 'MPOS App / accept', model: 'mpos-accept', selected: false, price: 0.25, percentage: 1.5 },
//   { name: 'E - COM Shop System / supr', model: 'ecom-shop', selected: false, price: 0.25, percentage: 1.8 },
//   { name: 'Stamp Card App / 10stamps', model: 'stamp-card', selected: false, price: 0.25, percentage: 1.9 },
//   { name: 'Live Chat App / kopplr.chat', model: 'live-chat', selected: false, price: 0.25, percentage: 0.7 }
// ]

const currencies = [
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'CHF', label: 'CHF' },
  { value: 'RON', label: 'RON' },
]

export default new Vuex.Store({
  state: {
    user,
    company,
    bank,
    paymentAcceptance,
    services,
    currencies,
    posQuantity: 0,
    dashSideModalContent: null,
    dashSideModalComponent: null,
    ui: {
      signupStep: 1,
      signupFinished: false,
      slideNumber: 1,
      menuOpen: false,
      dashSideOpen: true,
      userDashSideOpen: true,
      sideModalOpen: false,
      modals: {
        PosModal: {
          visible: false
        },
        MastercardModal: {
          visible: false
        }
      }
    },
    registration: {
      complete: false,
      progress: 0,
      step: 1
    }
  },
  getters: {
    getState(state) {
      return state
    },
    getField
  },
  mutations: {
    updateUser(state, userObj) {
      state.user = userObj;
    },
    incrementStep(state) {
      state.ui.signupStep++;
    },
    setSignupStep(state, step) {
      state.ui.signupStep = step;
    },
    setSignupFinished(state, payload) {
      state.ui.signupFinished = payload;
    },
    toggleMenu(state) {
      state.ui.menuOpen = !state.ui.menuOpen;
    },
    toggleDashSide(state) {
      state.ui.dashSideOpen = !state.ui.dashSideOpen;
    },
    hideDashSide(state) {
      state.ui.dashSideOpen = false;
    },
    changeFeatureSlide(state, slide) {
      state.ui.slideNumber = slide;
    },
    changeRegisterStep(state, step) {
      state.registration.step = step;
    },
    changeRegisterStatus(state, status) {
      state.registration[status.key] = status.val
    },
    changeProgress(state, progress) {
      state.registration.progress = progress
    },
    showHideModal(state, payload) {
      state.ui.modals[payload.modal].visible = payload.show
    },
    showHideSideModal(state, payload) {
      setTimeout(() => {
        state.ui.sideModalOpen = payload.show
        state.dashSideModalContent = payload.payload
        state.dashSideModalComponent = payload.component
      }, 600)
    },
    updatePosField(state, selected) {
      const index = state.services.findIndex(s => s.model === 'terminal')
      state.services[index].selected = selected
    },
    updateMastercardField(state, selected) {
      const index = state.paymentAcceptance.findIndex(s => s.model === 'mastercard')
      state.paymentAcceptance[index].selected = selected
    },
    updateField
  },
  actions: {},
  plugins: [
    vuexLocal.plugin
  ]
});
